module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Semibold.af64ab08.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/themes/fonts/SFProDisplay-Semibold.woff2
// module id = 335
// module chunks = 1